import React, { useState } from 'react'
import { Link } from 'react-router-dom'

import { ReactComponent as ArrowDown } from '../../resources/img/firstSectionArrowDown.svg'
import '../../styles/resources/_titleCard.scss'
import { CSS } from '../../utils/domUtils'
import { PATHS } from '../../utils/paths'
import Header from '../common/Header'

const TitleCard: React.FC = () => {
	const [isMenuOpen, setIsMenuOpen] = useState(false)

	return (
		<>
			<div className={`${CSS.TITLE_CARD} ${CSS.BACKGROUND}`}>
				<div className={CSS.CONTAINER}>
					<Header setIsMenuOpen={setIsMenuOpen} isMenuOpen={isMenuOpen} />
					<div className={`${CSS.FLEX_CENTER} ${CSS.FLEX_COLUMN}`}>
						<h1 className={`${CSS.TITLE_CARD_TITLE} ${CSS.CARD_TITLE}`}>Resources</h1>
						<div className={CSS.CARD_TEXT}>
							Blog posts, technical papers, company updates and more. <br /> You can also visit our{' '}
							<Link to={PATHS.FAQ}>FAQ</Link> to find answers to common questions.
						</div>
					</div>

					<div className={CSS.TITLE_ARROW}>
						<ArrowDown />
					</div>
				</div>
			</div>
		</>
	)
}

export default TitleCard
